import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=495bef6a&scoped=true"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495bef6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495bef6a')) {
      api.createRecord('495bef6a', component.options)
    } else {
      api.reload('495bef6a', component.options)
    }
    module.hot.accept("./PersonModal.vue?vue&type=template&id=495bef6a&scoped=true", function () {
      api.rerender('495bef6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/PersonModal.vue"
export default component.exports